export const HIGHLIGHT_COLOR = "#87CEEB"
